import { IconChevron } from '../icons/WizardIcons';

export type WizardSelectOption = {
  id: string;
  label: string;
};

type Props = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder: string;
  options: WizardSelectOption[];
  disabled?: boolean;
  hasError?: boolean;
  clearable?: boolean;
  emptyMessage?: string;
};

export function fieldInputClass(hasError: boolean): string {
  return `ccr-inp${hasError ? ' inv' : ''}`;
}

/** Single-select dropdown aligned with MultiSelectChips (Extranet parity). */
export default function WizardSelect({
  id,
  value,
  onChange,
  onClear,
  placeholder,
  options,
  disabled = false,
  hasError = false,
  clearable = true,
  emptyMessage = 'No data found',
}: Props) {
  const showClear = clearable && Boolean(value) && !disabled;
  const isLoading = /loading/i.test(placeholder);
  const showNoData = !disabled && !isLoading && options.length === 0;

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    if (onClear) onClear();
    else onChange('');
  };

  return (
    <div
      className={`wizard-sel-wrap${disabled ? ' is-disabled' : ''}${showClear ? ' has-clear' : ''}${hasError ? ' inv' : ''}`}
    >
      <select
        id={id}
        className={`wizard-sel ${fieldInputClass(hasError)}${value ? '' : ' is-empty'}`}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return;
          onChange(e.target.value);
        }}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {showNoData ? (
          <option value="__empty__" disabled>
            {emptyMessage}
          </option>
        ) : (
          options.map((o) => (
            <option key={o.id} value={o.id}>
              {o.label}
            </option>
          ))
        )}
      </select>
      {showClear ? (
        <button
          type="button"
          className="wizard-sel-clear"
          aria-label="Clear selection"
          tabIndex={-1}
          onClick={handleClear}
        >
          ×
        </button>
      ) : null}
      <span className="wizard-sel-chev" aria-hidden>
        <IconChevron />
      </span>
    </div>
  );
}
